import { PageContainer } from "./styled";

export default PageContainer;
